export default __webpack_public_path__ + "static/media/chevron-down.15054766.webp";